module.exports = __webpack_public_path__ + "static/Survicate-85473f6242b2b4f54e55cea7a397803e.png";